// extracted by mini-css-extract-plugin
module.exports = {"whatsapp-button":"auth_whatsapp-button__UwaU4","wave-animation":"auth_wave-animation__e37Pz","icon":"auth_icon___0_eA"};